import { LineChart } from '@mui/x-charts/LineChart';
import ChartCard from '../../analytics/ChartCard';
import { StorageGrowthDataPoint } from '../../../../types/admin';

interface StorageGrowthChartProps {
  data: StorageGrowthDataPoint[];
  loading?: boolean;
}

export default function StorageGrowthChart({ data, loading }: StorageGrowthChartProps) {
  const dates = data.map((d) => new Date(d.date));
  const sizes = data.map((d) => d.size_gb);

  return (
    <ChartCard title="Storage Growth" subtitle="Last 30 days" loading={loading} height={400}>
      <LineChart
        xAxis={[
          {
            data: dates,
            scaleType: 'time',
            valueFormatter: (date) => new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
          },
        ]}
        yAxis={[
          {
            label: 'Storage (GB)',
          },
        ]}
        series={[
          {
            data: sizes,
            label: 'Storage Size',
            color: '#1976d2',
            showMark: false,
            area: true,
          },
        ]}
        grid={{ vertical: false, horizontal: true }}
        sx={{
          '& .MuiLineElement-root': {
            strokeWidth: 2,
          },
        }}
      />
    </ChartCard>
  );
}
